package at.theatervogelweide.admin.contract.connections

import at.theatervogelweide.admin.contract.AdminResult
import kotlinx.rpc.annotations.Rpc

/** Verbundene Anwendungen (#34): the MCP clients of all admins, newest first. */
@Rpc
interface ConnectionsService {
    suspend fun list(): AdminResult<List<McpConnection>>

    /** "Zugriff entziehen": the client's tokens stop working at once; connecting again needs a new sign-in. */
    suspend fun revoke(id: Long): AdminResult<Unit>
}
